import {Tabs, Pagination, Layout, message, ConfigProvider, Input, Table, Button, Row, Statistic, Col, Popconfirm, Popover} from 'antd'
import { Content } from 'antd/lib/layout/layout'
import React, { useState, useRef, useEffect } from 'react'
import Cookies from 'js-cookie'
import zhCN from 'antd/lib/locale/zh_CN'
import { sendHttpPostRequest } from '../../../api/http-request'
const { Search } = Input
import OAMSider from '../oam-sider'
import idataCourseTableStyles from '../../common/global-styles/idatacourse-table.module.less'
import PublicTipModal from '@/component/PublicTipModal/PublicTipModal'
import GlobalCss from '@/global.module.less'
import { BACKEND_API_URL } from '../../../constants/constants'
import UserCard from '../user/oam-userinfo-card'

const { TabPane } = Tabs
export interface Props {}

const statusMap = new Map([
  [1, '下线'],
  [2, '在线'],
])

export const OAMCourseList: React.FC<Props> = (props) => {
  const [userResult, setUserResult] = useState([] as any[]) // 当前显示的结果页
  const [resultSum, setResultSum] = useState(0) // 搜索返回的结果数
  const [onlineCount, setOnlineCount] = useState(0) // 上线的机构数
  const [totalCount, setTotalCount] = useState(0) // 搜索返回的结果数

  const [sysCount, setSysCount] = useState(0) //搜索返回的结果数
  const [userCount, setUserCount] = useState(0) //搜索返回的结果数


  const queryContent = useRef('') // 记录搜索串
  const order = useRef('') // 排序升序降序
  const order_by = useRef('') // 排序列
  const page = useRef(1) // 记录当前的页数
  const pageSize = useRef(10) // 记录当前每页展示数量
  const querySource = useRef('2') //2-系统，1-用户

  const newName = useRef('') // 名称
  const newDesc = useRef('') // 描述
  const [createModalVis, setCreateModalVis] = useState(false)
  const createOk = () => {
    const sessionid = Cookies.get('sessionid')
    let data = {
      name: newName.current,
      description: newDesc.current,
      sessionid: sessionid,
      sid: sessionid,
    }
    sendHttpPostRequest('course/api/oam_create_course/', data, (res) => {
      if (res.code == 0) {
        message.success('新建课程成功~')
        window.open(`/oam_course_edit?course_id=${res.course_id}`);
        setCreateModalVis(false)
        queryCourseList()
      } else {
        message.error(res.message)
      }
    })
    newName.current = ''
    newDesc.current = ''
    
  }

  const createCancel = () => {
    setCreateModalVis(false)
    newName.current = ''
    newDesc.current = ''
  }

  useEffect(() => {
    queryCourseList()
  }, [])

  // 查询课程列表
  const queryCourseList = () => {
    const sessionid = Cookies.get('sessionid')
    const queryData = {
      query: queryContent.current,
      page: page.current,
      pagesize: pageSize.current,
      order: order.current,
      order_by: order_by.current,
      source: querySource.current,
      sessionid: sessionid,
      sid: sessionid,
    }
    sendHttpPostRequest(
      'course/api/oam_query_course_list/',
      queryData,
      courseListCallback
    )
  }

  // 查询课程列表接口回调
  const courseListCallback = (response: any) => {
    // console.log(response);
    message.destroy()
    if (response.code == -100) {
      // 未登录
      window.location.href = '/oam_login?next=/oam_course_list'
    } else if (response.is_ok == true) {
      // 成功
      setUserResult(response.query_list)
      setResultSum(response.total_sum)
      setTotalCount(response.total_count)
      setOnlineCount(response.online_count)
      setSysCount(response.system_count)
      setUserCount(response.personal_count)
    } else if (response.code == -501) {
      // 权限不足
      window.location.href = '/oam_login?next=oam_course_list'
    } else {
      message.error(response.message)
    }
  }

  // 切换Tab页
  const onTabKeyChange = (key: string) => {
    console.log(key)
    querySource.current = key
    page.current = 1
    queryCourseList()
  }


  //页码和页数发生了变化
  const onPageChange = (newPage: number, newPageSize?: number | undefined) => {
    page.current = newPage ? newPage : 1
    if (newPageSize) {
      pageSize.current = newPageSize
    }
    queryCourseList()
  }

  // 渲染状态
  const renderStatus = (text: any, record: any) => (
    <div>{statusMap.get(parseInt(text))}</div>
  )

  //点击了编辑按钮
  const onEditBtnClick = (id: any, event: any) => {
    window.open('/oam_course_edit?course_id=' + id)
  }


  // 删除回调
  const onDeleteBtnClickCallback = (response: any) => {
    message.destroy()
    if (response.code == -100) {
      // 没登录
      window.location.href = '/oam_login?next=oam_course_list'
    } else if (response.code == -501) {
      // 没权限
      window.location.href = '/oam_login?next=oam_course_list'
    } else if (response.code == 0) {
      message.success(response.message)
      queryCourseList()
    } else {
      message.error(response.message)
    }
  }

  // 点击 删除
  const onDeleteBtnClick = (courseId: string) => {
    sendHttpPostRequest(
      'course/api/oam_delete_course/',
      {
        sessionid: Cookies.get('sessionid'),
        course_id: courseId,
      },
      onDeleteBtnClickCallback
    )
  }

  // 上下架回调
  const onPutOnOffBtnClickCallback = (response: any) => {
    message.destroy()
    if (response.code == -100) {
      // 没登录
      window.location.href = '/oam_login?next=oam_course_list'
    } else if (response.code == -501) {
      // 没权限
      window.location.href = '/oam_login?next=oam_course_list'
    } else if (response.is_ok == true) {
      message.success(response.message)
      queryCourseList()
    } else {
      message.error(response.message)
      queryCourseList()
    }
  }

  // 点了上下架按钮
  const onPutOnOffBtnClick = (courseId: number, status: number) => {
    sendHttpPostRequest(
      'course/api/oam_update_course/',
      {
        course_id: courseId,
        status: status == 1 ? 2 : 1,
        sessionid: Cookies.get('sessionid'),
        sid: Cookies.get('sessionid'),
      },
      onPutOnOffBtnClickCallback
    )
  }

  // 渲染操作
  const renderSystemActions = (text: any, record: any) => {
    return (
      <Row justify="center" align="middle" gutter={[8, 4]} wrap={false}>
        <Col style={{ width: 50 }}>
          <Button
            style={{ borderRadius: 20, fontSize: 14 }}
            size="small"
            id="editit"
            type="dashed"
            onClick={onEditBtnClick.bind(this, record.id)}
          >
            {' '}
            编辑
          </Button>
        </Col>

        {
          <Col style={{ width: 50 }}>
            {' '}
            {parseInt(record.status) == 1 ? (
              <Button
                style={{ borderRadius: 20, fontSize: 14 }}
                size="small"
                id="puton"
                value={record.id}
                type="primary"
                onClick={onPutOnOffBtnClick.bind(
                  this,
                  record.id,
                  record.status
                )}
              >
                {' '}
                上 架{' '}
              </Button>
            ) : (
              <Popconfirm
                placement="top"
                title={'确认下架课程"' + record.name + '"吗？'}
                onConfirm={onPutOnOffBtnClick.bind(
                  this,
                  record.id,
                  record.status
                )}
                okText="确认"
                cancelText="取消"
              >
                <Button
                  style={{ borderRadius: 20, fontSize: 14 }}
                  size="small"
                  id="putoff"
                  value={record.id}
                  type="primary"
                  danger
                >
                  {' '}
                  下 架{' '}
                </Button>
              </Popconfirm>
            )}
          </Col>
        }

        
          <Col style={{ width: 50 }}>

            {parseInt(record.status) == 1 && (
              <Popconfirm
                placement="top"
                title={'确认删除课程"' + record.name + '"吗？'}
                onConfirm={onDeleteBtnClick.bind(this, record.id)}
                okText="确认"
                cancelText="取消"
              >
                <Button
                  style={{ borderRadius: 20, fontSize: 14 }}
                  size="small"
                  id="deleteexe"
                  type="dashed"
                  danger
                >
                  {' '}
                  删除
                </Button>
              </Popconfirm>   )}

              {parseInt(record.status) != 1 && (

                <Button
                  style={{ borderRadius: 20, fontSize: 14 }}
                  size="small"
                  id="deleteexe"
                  type="dashed"
                  danger
                  disabled={true}
                >
                  {' '}
                  删除
                </Button>
               )}


          </Col>
      
      </Row>
    )
  }

  // 渲染操作
  const renderUserActions = (text: any, record: any) => {
    return (
      <Row justify="center" align="middle" gutter={[8, 4]} wrap={false}>
        <Col style={{ width: 50 }}>
          <Button
            style={{ borderRadius: 20, fontSize: 14 }}
            size="small"
            id="editit"
            type="dashed"
            onClick={onEditBtnClick.bind(this, record.id)}
          >
            {' '}
            编辑
          </Button>
        </Col>

        <Col style={{ width: 50 }}>
          <Popconfirm
            placement="top"
            title={'确认删除课程"' + record.name + '"吗？'}
            onConfirm={onDeleteBtnClick.bind(this, record.id)}
            okText="确认"
            cancelText="取消"
          >
            <Button
              style={{ borderRadius: 20, fontSize: 14 }}
              size="small"
              id="deleteexe"
              type="dashed"
              danger
            >
              {' '}
              删除
            </Button>
          </Popconfirm>
        </Col>
      </Row>
    )
  }



  //点击了搜索按钮
  const onSearchBtn = (value: string) => {
    page.current = 1
    queryContent.current = value
    queryCourseList()
  }

  // 表格发生变化
  const onTableChange: any = (
    pagination: any,
    filters: any,
    sorter: any,
    extra: { currentDataSource: []; action: any }
  ) => {
    if (sorter.order) {
      //如果选择了排序列
      order.current = sorter.order
      order_by.current = sorter.field
    }

    page.current = 1
    queryCourseList()
  }

  // 表格列
  const systemCols: any = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      align: 'left',
      width: 50,
      ellipsis: true
    },
    {
      title: '课程名',
      dataIndex: 'name',
      key: 'name',
      width: 150,
      align: 'left',
      ellipsis: true,
    },
    {
      title: '创建者',
      dataIndex: 'user_name',
      key: 'user_name',
      width: 80,
      ellipsis: true,
      align: 'left',
      render: (text: any, record: any) =>
      {
        if (record.user_id !== 0) {
          return (
            <Row align="middle" justify="start" wrap={false}>
              <Col flex="40px">
                <Popover
                  arrowPointAtCenter={true}
                  trigger="hover"
                  placement="left"
                  content={<UserCard user_id={record.user_id} />}
                  title={null}
                >
                  <img
                    onMouseOver={() => {}}
                    style={{
                      width: 30,
                      height: 30,
                      borderRadius: 15,
                      cursor: 'pointer',
                    }}
                    src={record?.creator_avatar?.startsWith('http') ? record?.creator_avatar : BACKEND_API_URL + record?.creator_avatar}
                  />
                </Popover>
              </Col>
              <Col flex="80px">
                <span>
                  {record.teacher_real_name == ''
                    ? text
                    : record.teacher_real_name}
                </span>
              </Col>
            </Row>
          )
        }
      },

    },
    {
      title: '创建时间',
      dataIndex: 'create_time',
      key: 'create_time',
      width: 180,
      align: 'center',
      sorter: true,
      ellipsis: true,
      sortDirections: ['descend', 'ascend'],
    },
    {
      title: '开始日期',
      dataIndex: 'start_time',
      key: 'start_time',
      width: 100,
      align: 'center',
      sorter: true,
      ellipsis: true,
      sortDirections: ['descend', 'ascend'],
      render: (text: any, record: any) => {
        return text.slice(0, 10)
      },
    },
    {
      title: '结束日期',
      dataIndex: 'end_time',
      key: 'end_time',
      width: 100,
      align: 'center',
      sorter: true,
      ellipsis: true,
      sortDirections: ['descend', 'ascend'],
      render: (text: any, record: any) => {
        return text.slice(0, 10)
      },
    },
    {
      title: '状态',
      dataIndex: 'status',
      key: 'status',
      width: 50,
      ellipsis: true,
      align: 'center',
      render: renderStatus,
      filters: [
        {
          text: '下线',
          value: 1,
        },
        {
          text: '在线',
          value: 2,
        },
      ],
      onFilter: (value: any, record: any) => true,
    },

    {
      title: '操作',
      dataIndex: 'actions',
      key: 'actions',
      width: 150,
      ellipsis: true,
      align: 'center',
      fixed: 'right',
      render: renderSystemActions,
    },
  ]

  // 表格列
  const userCols: any = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      align: 'left',
      width: 50,
      ellipsis: true,
    },
    {
      title: '课程名',
      dataIndex: 'name',
      key: 'name',
      width: 150,
      align: 'left',
      ellipsis: true
    },
    {
      title: '创建者',
      dataIndex: 'user_name',
      key: 'user_name',
      width: 150,
      ellipsis: true,
      align: 'left',

      render: (text: any, record: any) =>
      {
        if (record.user_id !== 0) {
          return (
            <Row align="middle" justify="start" wrap={false}>
              <Col flex="40px">
                <Popover
                  arrowPointAtCenter={true}
                  trigger="hover"
                  placement="left"
                  content={<UserCard user_id={record.user_id} />}
                  title={null}
                >
                  <img
                    onMouseOver={() => {}}
                    style={{
                      width: 30,
                      height: 30,
                      borderRadius: 15,
                      cursor: 'pointer',
                    }}
                    src={record?.creator_avatar?.startsWith('http') ? record?.creator_avatar : BACKEND_API_URL + record?.creator_avatar}
                  />
                </Popover>
              </Col>
              <Col flex="80px">
                <span>
                  {record.teacher_real_name == ''
                    ? text
                    : record.teacher_real_name}
                </span>
              </Col>
            </Row>
          )
        }
      },

    },
    {
      title: '所属机构',
      dataIndex: 'college_name',
      key: 'college_name',
      width: 80,
      align: 'left',
      ellipsis: true
    },
    {
      title: '创建时间',
      dataIndex: 'create_time',
      key: 'create_time',
      width: 180,
      align: 'center',
      sorter: true,
      sortDirections: ['descend', 'ascend'],
      ellipsis: true,
    },
    {
      title: '开始日期',
      dataIndex: 'start_time',
      key: 'start_time',
      width: 100,
      align: 'center',
      sorter: true,
      ellipsis: true,
      sortDirections: ['descend', 'ascend'],
      render: (text: any, record: any) => {
        return text.slice(0, 10)
      },
    },
    {
      title: '结束日期',
      dataIndex: 'end_time',
      key: 'end_time',
      width: 100,
      align: 'center',
      ellipsis: true,
      sorter: true,
      sortDirections: ['descend', 'ascend'],
      render: (text: any, record: any) => {
        return text.slice(0, 10)
      },
    },
    {
      title: '操作',
      dataIndex: 'actions',
      key: 'actions',
      width: 200,
      ellipsis: true,
      fixed: 'right',
      align: 'center',
      render: renderUserActions,
    },
  ]

  return (
    <Layout style={{ minHeight: '100vh' , minWidth:1200}}>
      <OAMSider keys={'31'} openKeys={['sub-course']}></OAMSider>
      <Layout style={{ backgroundColor: '#f9f9f9' }}>
        <Content
          style={{
            backgroundColor: '#fff',
            borderRadius: 5,
            minWidth: 400,
            margin: 30,
            paddingTop: 20,
          }}
        >
          <div style={{ paddingLeft: 30, paddingRight: 30 }}>
            <div
              className={'css.search1'}
              style={{ textAlign: 'left', paddingBottom: 20 }}
            >
              <Row align="middle" gutter={16}>
                <Col flex="80px">
                  <Statistic title="课程总数" value={totalCount} />
                </Col>
                <Col flex="80px">
                  <Statistic title="系统" value={sysCount} />
                </Col>
                <Col flex="80px">
                  <Statistic title="用户" value={userCount} />
                </Col>
                <Col flex="80px">
                  <Statistic title="已上架" value={onlineCount} />
                </Col>
                <Col flex="350px">
                  <Search
                    placeholder="搜索课程"
                    style={{ width: 350 }}
                    enterButton={true}
                    onSearch={onSearchBtn}
                    className={idataCourseTableStyles.oamSearch}
                  />
                </Col>

                <Col flex="auto" style={{ textAlign: 'right' }}>
                  <Button
                    type="primary"
                    style={{
                      float: 'right',
                      marginRight: 20,
                      borderRadius: 20,
                       textShadow:'none', boxShadow:'none'
                    }}
                    onClick={()=>{newName.current = ''; newDesc.current=''; setCreateModalVis(true)}}
                  >
                    创建课程
                  </Button>
                </Col>
              </Row>
            </div>

            <Tabs defaultActiveKey="2" onChange={onTabKeyChange}>
              <TabPane tab="系统" key="2" className="">
                <div style={{height:500}} className={idataCourseTableStyles.tableWrapper}>
                  <ConfigProvider locale={zhCN}>
                    <Table
                      dataSource={userResult}
                      columns={systemCols}
                      rowKey={(record) => record.id}
                      pagination={false}
                      scroll={{ x: 800 }}
                      onChange={onTableChange}
                    />
                  </ConfigProvider>
                </div>

                <ConfigProvider locale={zhCN}>
                  <div style={{ marginTop:20, marginBottom: 30,}} className={'css.pagination'}>
                    <Pagination
                      defaultCurrent={1}
                      total={resultSum}
                      defaultPageSize={10}
                      hideOnSinglePage={true}
                      onChange={onPageChange}
                      showSizeChanger={false}
                      current={page.current}
                      showQuickJumper={true}
                      showTotal={(total) => `共 ${total} 课程`}
                    />
                  </div>
                </ConfigProvider>
              </TabPane>

              <TabPane tab="用户" key="1" className="">
                <div style={{minHeight:500}}  className={idataCourseTableStyles.tableWrapper}>
                  <ConfigProvider locale={zhCN}>
                    <Table
                      dataSource={userResult}
                      columns={userCols}
                      rowKey={(record) => record.id}
                      pagination={false}
                      scroll={{ x: 800 }}
                      onChange={onTableChange}
                    />
                  </ConfigProvider>
                </div>

                <ConfigProvider locale={zhCN}>
                  <div style={{ marginTop:20, marginBottom: 30,}} className={'css.pagination'}>
                    <Pagination
                      defaultCurrent={1}
                      total={resultSum}
                      defaultPageSize={10}
                      hideOnSinglePage={true}
                      showSizeChanger={false}
                      onChange={onPageChange}
                      current={page.current}
                      showQuickJumper={true}
                      showTotal={(total) => `共 ${total} 课程`}
                    />
                  </div>
                </ConfigProvider>
              </TabPane>
            </Tabs>
          </div>
        </Content>


        <PublicTipModal
          modalContent={<div>
            <Row align={'middle'} justify={'start'} className={GlobalCss.formRow}>
            <Col className={GlobalCss.requiredLabel}>名称</Col>
            <Col>
              <Input
                style={{
                  width: '300px',
                }}
                placeholder="请输入课程名称"
                maxLength={50}
                onChange={(e) => {
                 newName.current = e.target.value
                }}
              />
            </Col>
          </Row>
          <Row align={'top'} justify={'start'} className={GlobalCss.formRow} style={{marginTop:15}}>
            <Col className={GlobalCss.requiredLabel}>介绍</Col>
            <Col>
              <Input.TextArea
                style={{
                  minHeight: '145px',
                  width: '300px',
                }}
                placeholder="请输入课程介绍"
                onChange={(e) => {newDesc.current = e.target.value}}
              />
            </Col>
          </Row>
          </div>
          }
          modalTitle={'创建课程'}
          handleOk={createOk}
          handleCancel={createCancel}
          open={createModalVis}
          setOpen={setCreateModalVis}
        />

      </Layout>
    </Layout>
  )
}

export default OAMCourseList
